import * as React from 'react';
import { v4 as uuid } from 'uuid';

import { projectsActionCreators } from 'src/actions/projects/actionCreators';
import { useLocalModel } from 'src/containers/ProjectModelDialog/hooks/useLocalModelValue';
import {
  validateProjectModelIri,
  validateProjectModelName,
} from 'src/containers/ProjectModelDialog/hooks/validators';
import { useReduxDispatch } from 'src/utils/hooks/useReduxDispatch';
import { useRouterParams } from 'src/utils/hooks/useRouterParams';

export const useAddLocalModel = () => {
  const dispatch = useReduxDispatch();
  const { projectId } = useRouterParams();
  const { name, namespace } = useLocalModel();

  const nameValidationError = validateProjectModelName(name);
  const namespaceValidationError = validateProjectModelIri(namespace);

  const isAddLocalModelEnabled = Boolean(
    name && namespace && !nameValidationError && !namespaceValidationError
  );

  const handleAddLocalModel = React.useCallback(() => {
    if (!isAddLocalModelEnabled) {
      return;
    }

    dispatch(
      projectsActionCreators.addedLocalModelToProject(projectId, {
        id: uuid(),
        name,
        namespace,
        dateLastUpdated: Date.now(),
      })
    );
  }, [dispatch, isAddLocalModelEnabled, name, namespace, projectId]);

  return {
    handleAddLocalModel,
    isAddLocalModelEnabled,
    nameValidationError,
    namespaceValidationError,
  };
};
